/**
 * Product Detail Page (PDP) Mobile Layout Manager
 * =============================================
 * 
 * This script handles the responsive layout adjustments for the product detail page,
 * specifically managing the transition between mobile and desktop views.
 * 
 * Functionality:
 * - Creates a mobile-specific slider container for smaller screens (< 769px)
 * - Manages the relocation of key elements:
 *   1. Media Gallery (product images)
 *   2. Icon with Text section
 * - Automatically restores desktop layout when viewport width increases
 * - Maintains original parent references for proper DOM restoration
 * 
 * Elements affected:
 * - .product__text: Main product information container
 * - media-gallery: Product image gallery component
 * - .icon-with-text--horizontal: Icons and text information section
 * 
 * Breakpoint:
 * - Mobile: < 769px
 * - Desktop: >= 769px
 */

document.addEventListener('DOMContentLoaded', function() {
    // Create mobile slider container
    const mobileSliderContainer = document.createElement('div');
    mobileSliderContainer.id = 'mobile-slider-mov';
    mobileSliderContainer.classList.add('mobile-slider-container');

    // Get the elements we need to work with
    const productText = document.querySelector('.product__text');
    const mediaGallery = document.querySelector('media-gallery');
    const iconWithText = document.querySelector('.icon-with-text--horizontal');
    const thumbnailSlider = document.querySelector('.thumbnail-slider');
    
    // Original parent elements to restore desktop layout
    let mediaGalleryParent = null;
    let iconWithTextParent = null;
    let thumbnailSliderParent = null;
    
    function handleMobileLayout() {
        const isMobile = window.innerWidth < 769;
        
        if (isMobile && productText && mediaGallery && iconWithText) {
            // Save original parents if not already saved
            if (!mediaGalleryParent) mediaGalleryParent = mediaGallery.parentElement;
            if (!iconWithTextParent) iconWithTextParent = iconWithText.parentElement;
            if (!thumbnailSliderParent && thumbnailSlider) thumbnailSliderParent = thumbnailSlider.parentElement;
            
            // Insert mobile slider container after product text if not already done
            if (!document.getElementById('mobile-slider-mov')) {
                productText.insertAdjacentElement('afterend', mobileSliderContainer);
            }
            
            // Move elements to mobile slider (except thumbnail slider)
            mobileSliderContainer.appendChild(mediaGallery);
            mobileSliderContainer.appendChild(iconWithText);

            // Move thumbnail slider as a separate section after mobile-slider-mov
            if (thumbnailSlider) {
                // First remove it from current location if needed
                if (thumbnailSlider.parentElement) {
                    thumbnailSlider.remove();
                }
                // Place it after mobile-slider-mov as a separate section
                mobileSliderContainer.insertAdjacentElement('afterend', thumbnailSlider);
            }
        } else {
            // Reset to desktop layout
            if (mediaGalleryParent && mediaGallery) {
                mediaGalleryParent.appendChild(mediaGallery);
            }
            if (iconWithTextParent && iconWithText) {
                iconWithTextParent.appendChild(iconWithText);
            }
            if (thumbnailSliderParent && thumbnailSlider) {
                thumbnailSliderParent.appendChild(thumbnailSlider);
            }
            
            // Remove mobile slider container if it exists
            if (document.getElementById('mobile-slider-mov')) {
                mobileSliderContainer.remove();
            }
        }
    }

    // Handle layout on load and resize
    handleMobileLayout();
    window.addEventListener('resize', handleMobileLayout);
});
